<template >
    <v-sheet
        class="mx-auto pt-2 text-center"
        max-width="700"
    >
        <v-slide-group
            v-model="model"
            center-active
            show-arrows
            active-class="active"
        >
            <v-slide-item
                v-for="(floor,index) of data.floors"
                :key="index"
                v-slot="{ active, toggle }"
            >
                <!-- <v-chip
                    class="ma-2"
                    :class="{'active': index === currentFloor}"
                    outlined
                    @click.prevent="selectFloor(floor)"
                >    -->

                <v-btn
                    class="ma-2 text-none habiteo-body-2 cutaway-filter-cta"
                    :input-value="active"
                    depressed
                    rounded
                    outlined
                    small
                    @click.prevent="selectFloor(floor); toggle();"
                    :ripple="false"
                >
                    <span class="pr-1">
                        {{ floor.text }} 
                        </span>
                        <span v-if="index === currentFloor">
                            {{ plotCount }}
                    </span>
                </v-btn>
                    
                <!-- </v-chip> -->
            </v-slide-item>
        </v-slide-group>
    </v-sheet>
</template>

<script>
    import {  mapGetters } from 'vuex';
    import { EventBus } from '@/event-bus';

    export default {
        name: "CutawayFloorsFooter",
        props: ["data"],
        data: () => ({
            model: null
        }),
        computed:{
            ...mapGetters('widget', [
                'showPlotCount'
            ]),
            plotCount() {
                return this.showPlotCount ? ' (' + (this.data.floors[this.currentFloor].hotspots ? this.data.floors[this.currentFloor].hotspots.length : 0) + ')' : '';
            },
            currentFloor() {
                return this.$props.data.floors ? this.$props.data.floors.findIndex(floor => floor.active) : null;
            }, 
        },
        mounted() {
            this.model = this.currentFloor;
        },
        methods: {
            getCurrentFloor(floor){
                this.$props.data.floors.filter(el => el.active).forEach(el => el.active = false);
                this.$props.data.floors.filter(el => el.id === floor.id)[0].active = true;
                EventBus.$emit('updateCutawayData', floor);
            },
            selectFloor(floor) {
                this.getCurrentFloor(floor);
                this.applyFilters();
            },
            applyFilters() {
                if (this.$props.data.lotView === 'both') {
                    EventBus.$emit('3d_FilterHotspot');
                    EventBus.$emit('plotgrid_FilterHotspot', this.$props.data.filters);
                } else if (this.$props.data.lotView === '3d')
                    EventBus.$emit('3d_FilterHotspot');
                else
                    EventBus.$emit('plotgrid_FilterHotspot', this.$props.data.filters);
            },
        },  
    }
</script>

<style lang="scss" scoped>
    .v-slide-group {
        .cutaway-filter-cta {
            letter-spacing: unset;
            text-indent: unset;
            background-color: white;
            border-color: rgba(0,0,0,.12);
            color: rgba(0,0,0,.87);
        }
        .v-slide-group__next--disabled {
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/layout/alternative/cutaway/components/CutawayFloorsFooter.vue